export enum Permissions {
    FlowRead = '1b23dce6-3023-5cd0-90dd-7ff20c2dca23',
    FlowCreate = '95f4bdf8-50b8-5c3a-aa09-06013f282804',
    FlowUpdate = 'f72f4a25-af0d-5c5f-8f83-a2792ffd49bb',
    FlowDelete = '4208bf47-77d2-5883-a3ce-a0ddf90e89bb',
    AppRead = '3d2fa622-1adc-5c1a-89f0-4083ac2108e4',
    AppCreate = 'c15b3a3d-da6e-5a33-b873-f99b0b817e7e',
    AppUpdate = '3933f0b0-c8af-5b78-b9f5-1ad8bce9a06c',
    AppDelete = 'ded6b90d-ed31-55fd-b9b7-c59fd9b373be',
    ContentRead = '9444b972-5c79-51c9-8680-cb51cb9e573d',
    ContentCreate = 'cc219e5b-08ef-5249-a5a1-758ad77ea93d',
    ContentUpdate = '936b2310-fc71-5299-be81-c0bd38394503',
    ContentDelete = '662c6513-3f3d-5cf7-a9a5-3985e7618b5d',
    EnvironmentRead = '935ddc47-2bc9-5662-88ee-32803740d0cc',
    EnvironmentCreate = '4c6a1115-0026-5663-afcc-edfd273feac2',
    EnvironmentUpdate = '076e4777-ee63-56ac-82e9-93a555de04bf',
    EnvironmentDelete = 'b5efa5ff-fc8e-5004-a95e-bb2732c89a71',
    EnvironmentDeploy = 'f9bd355f-6877-55bd-9a8f-780588a447b3',
    FlowRun = '1f49aac8-8142-5233-aa31-514b710be8aa',
    ServiceRead = '86ef59a1-35f5-4f84-a1fb-a5ce34a8e63f',
    ServiceCreate = 'f3971b88-7ed3-4df8-85d9-b39be4277cdd',
    ServiceUpdate = '9c7dd148-9b6a-4fb9-8450-bc55e8ada705',
    ServiceDelete = 'd6d89fb7-96a3-42c1-94dc-788e8f89e00e',
    ServiceConnectionRead = '6fa1d59c-9b3f-4310-bc09-f4972a63f223',
    ServiceConnectionCreate = '14678d6e-a6c8-4fc9-bf4a-8d717480fd7d',
    ServiceConnectionUpdate = '617b84a5-8d4d-4800-ae18-61d525462874',
    ServiceConnectionDelete = '084bd4a1-4f3b-4e70-b614-95560bd1ad56',
    PermissionRead = 'd47d3dbe-73d8-4123-8537-e1a28b697ea3',
    PermissionCreate = 'abc21259-ecff-4955-9e5b-4cce7db0ede2',
    PermissionUpdate = 'f502bc17-5d6b-4884-8f83-77e1e88052c4',
    PermissionDelete = '456bb226-dcc7-4e5f-b950-0255bbe62028',
    RoleRead = 'e6c7f26c-25bd-4bf1-9172-72bd73d4d93b',
    RoleCreate = '6c7c9748-d1d4-4f22-90c6-940f04a1a95b',
    RoleUpdate = '5989fcd1-0dc6-49c7-b345-349ced74cb21',
    RoleDelete = '1d939fec-81a1-4508-b2d1-55bf7478d6a3',
    RoleAssign = 'f6cc96d6-01f7-441c-880d-3979d41bd5ed',
    RoleUnassign = '0d559cbe-9124-45f5-aa7a-950eb1bd4191',
    DashboardRead = 'b25b5022-c241-4e77-8cdf-15a57dc51329',
    DashboardRefresh = '10dbb136-1fc2-43de-a0d7-28d1d8dee265',
    ProjectRead = '6c817ed8-eb0b-4b50-80d8-101ceafdd152',
    ProjectCreate = 'ce8547ca-298b-4fe2-a03a-fc15245432bb',
    ProjectUpdate = '73b8f4b4-e0d4-4a11-857c-d98bd56e1e0f',
    IntegrationEventRead = 'b2b5d87a-e948-4f15-abfe-5ea8b953a1f2',
    IntegrationEventCreate = '0c4f7ed4-8b6b-49cf-a344-551c1f3f9204',
    IntegrationEventUpdate = '32dd8c84-4889-4525-a8a7-966013e49cd4',
    IntegrationEventDelete = '560fe3dc-2099-44d2-9249-b0d2efa124f8',
    FileRead = 'b39c566f-39db-4e16-9b68-818223adc397',
    FileCreate = 'c002b17d-c378-4038-ab90-adce5bb8d8c1',
    FileUpdate = '6f3b2eb0-b5b1-4cda-bf18-c36aff4a906b',
    FileDelete = '3be1dba7-27c9-446b-aa53-0d0b99d88c80',
    ConversationRead = '57249657-41b0-4979-85bb-cc77989e0a38',
    ConversationUpdate = '75776e4e-c7cf-40e9-af6a-9e8949959a85',
    ConversationDelete = '79021b97-e952-435f-8b73-5d891f7ca84d',
    ChangeSetRead = 'b7473a2b-f670-4825-9676-cbdd95ddb730',
    ChangeSetCreate = '7714ca8a-5605-41a9-9258-ba84f430ff42',
    ChangeSetUpdate = 'b14d4a12-16aa-4902-9cfd-0f8e5c66770f',
    AuditRead = '11f3b067-4d1e-409f-bffe-7a0eba02a7ad',
    AgentRead = '38643758-e9c8-4361-a174-5a838d2c46af',
    AgentCreate = 'b4d6c287-91c0-4604-a3aa-a2fc5b7d5996',
    AgentUpdate = 'e4bd658f-4394-44e0-a3fa-6efabd24c0bb',
    AgentDelete = '1ab86e4b-f778-4ded-aecb-f0ad872ea148',
    UserRead = '16b9aa0f-611b-47cc-9c35-723638679787',
    UserUpdate = '8ad78496-a88b-404c-91ab-b568d7d7ec7f',
}
